var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.80469 8.2377L14.0005 13.8349L25.1963 8.2377C25.1548 7.52432 24.8422 6.85378 24.3224 6.36342C23.8027 5.87305 23.1151 5.59997 22.4005 5.6001H5.60049C4.88591 5.59997 4.19831 5.87305 3.67854 6.36342C3.15876 6.85378 2.84613 7.52432 2.80469 8.2377Z",
    fill: "#00A0AE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2008 11.3652L14.0008 16.9652L2.80078 11.3652V19.6C2.80078 20.3426 3.09578 21.0548 3.62088 21.5799C4.14598 22.105 4.85818 22.4 5.60078 22.4H22.4008C23.1434 22.4 23.8556 22.105 24.3807 21.5799C24.9058 21.0548 25.2008 20.3426 25.2008 19.6V11.3652Z",
    fill: "#00A0AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailFilled);
export default __webpack_public_path__ + "static/media/email-filled.217462f078f6e2938df331c553f7b6db.svg";
export { ForwardRef as ReactComponent };